import { render, staticRenderFns } from "./kpis.vue?vue&type=template&id=c6288964&scoped=true"
import script from "./kpis.vue?vue&type=script&lang=js"
export * from "./kpis.vue?vue&type=script&lang=js"
import style0 from "./kpis.vue?vue&type=style&index=0&id=c6288964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6288964",
  null
  
)

export default component.exports